import { screenApi } from 'apis'
import { ActionsCreator, basicHandlers, mergeMetadata } from '../lib'
import { RequestSchema } from 'redux/schemas'

export const requestsActions = new ActionsCreator({ Api: screenApi, actionTypesPrefix: 'requests' })

export const fetchRequests = (query) =>
  requestsActions.fetch({
    url: '/requests',
    query,
    schema: { requests: [RequestSchema] },
  })

export const createRequest = (payload) =>
  requestsActions.create({
    url: '/requests',
    payload,
    schema: { request: RequestSchema },
  })

export const fetchRequest = (requestId) =>
  requestsActions.fetch({
    url: `/requests/${requestId}`,
    schema: { request: RequestSchema },
  })

export const updateRequest = (requestId, payload) =>
  requestsActions.update({
    url: `/requests/${requestId}`,
    payload,
    schema: { request: RequestSchema },
  })

export const deleteRequest = (requestId) =>
  requestsActions.delete({
    url: `/requests/${requestId}`,
    schema: { request: RequestSchema },
  })

export const requestsCustomHandlers = {
  [requestsActions.actionTypes.DELETED]: basicHandlers.mergeEntities,
  [requestsActions.actionTypes.FETCHED]: mergeMetadata('requests'),
}
